// extracted by mini-css-extract-plugin
export const accordion = "accordion-module--accordion--2KTf2";
export const row = "accordion-module--row--2QWdc";
export const button = "accordion-module--button--3Aw5m";
export const panel = "accordion-module--panel--2qAC9";
export const fadein = "accordion-module--fadein--co5Sq";